module.exports = {
    SENTRY_URL: 'https://216c619653e144b09f7194d3bef979ff@sentry.io/1862578',
    ONBOARDING_COMPLETE_KEY: 'isOnboardingCompleted',
};
